import { render, staticRenderFns } from "./homeShowWap.vue?vue&type=template&id=32c9b9fc&scoped=true"
import script from "./homeShowWap.vue?vue&type=script&lang=js"
export * from "./homeShowWap.vue?vue&type=script&lang=js"
import style0 from "./homeShowWap.vue?vue&type=style&index=0&id=32c9b9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9b9fc",
  null
  
)

export default component.exports